import { ToastCustom } from "@components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { resolveInsight } from "../services";
import { INSIGHTS_QUERY_KEY } from "./insight-query-keys";

const getErrorMessage = (error: unknown) => {
	if (error instanceof Error) {
		return error.message;
	}

	return "Não foi possível marcar o insight como resolvido.";
};

export const useResolveInsightMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (insightId: number) => resolveInsight(insightId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [INSIGHTS_QUERY_KEY] });
		},
		onError: (error) => {
			toast(
				ToastCustom({ description: getErrorMessage(error), title: "Erro" })
			);
		},
	});
};
